<template>
  <div class="hello">
    <Navbar></Navbar>
    <h4 class="card-title" style="padding-top:30px;padding-bottom:30px;background-color:#c3c3c338;">
      <a href="/faq" style="color:#010101 !important;">FAQ</a>: Legal issues & Best practices
    </h4>
    <div class="container">
      <div class="row">
        <div class="col-md-4" style="text-align:justify;">
          <p>As per the laws of the country, Snakes are protected under the provisions of the Wildlife (Protection) Act- 1972. The protection is given to snakes considering their ecological value and to safeguard them from the Illegal Wildlife Trade where live snakes, snake venom, snakeskin are traded by criminals.</p>
        </div>
        <div class="col-md-8">
          <b-card no-body class="mb-1" style="text-align: left;">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-btn
                block
                href="#"
                v-b-toggle.accordion1
                variant="secondary"
                style="text-align:left;"
              >
                Are snakes protected under laws in India?
                <span
                  class="when-opened"
                  style="float:right;"
                >
                  <font-awesome-icon icon="minus-square" />
                </span>
                <span class="when-closed" style="float:right;">
                  <font-awesome-icon icon="plus-square" />
                </span>
              </b-btn>
            </b-card-header>

            <b-collapse
              id="accordion1"
              role="tabpanel"
              style="padding-left: 10px;
    padding-right: 10px;"
            >Yes, snakes are protected as wild animals under various schedules of the Wildlife (Protection) Act, 1972. Illegal hunting and possession of such protected snakes/ its body parts / venom are punishable offenses under the Act. The severity of punishment depends on the location (inside a protected area / outside the protected area) of the offense and the species of snake involved.</b-collapse>
          </b-card>
          <b-card no-body class="mb-1" style="text-align: left;">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-btn
                block
                href="#"
                v-b-toggle.accordion2
                variant="secondary"
                style="text-align:left;"
              >
                Why the snake charming is illegal in India?
                <span
                  class="when-opened"
                  style="float:right;"
                >
                  <font-awesome-icon icon="minus-square" />
                </span>
                <span class="when-closed" style="float:right;">
                  <font-awesome-icon icon="plus-square" />
                </span>
              </b-btn>
            </b-card-header>

            <b-collapse
              id="accordion2"
              role="tabpanel"
              style="padding-left: 10px;
    padding-right: 10px;"
            >Snake charmers violate the wildlife laws of the country by keeping protected wildlife in their custody without permission from authorities. This is a punishable offence under the Wildlife (Protection) Act, 1972. Moreover, snakes are mistreated by most charmers and often die due to acquired infections. Many snake charmers are also involved in duping the general public with promises ‘naagmani’ (which does not exist) as well as trading in banned wildlife products. Hence, snake charming is discouraged is India.</b-collapse>
          </b-card>
          <b-card no-body class="mb-1" style="text-align: left;">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-btn
                block
                href="#"
                v-b-toggle.accordion3
                variant="secondary"
                style="text-align:left;"
              >
                If I kill a snake that entered my house, will I get arrested?
                <span
                  class="when-opened"
                  style="float:right;"
                >
                  <font-awesome-icon icon="minus-square" />
                </span>
                <span class="when-closed" style="float:right;">
                  <font-awesome-icon icon="plus-square" />
                </span>
              </b-btn>
            </b-card-header>

            <b-collapse
              id="accordion3"
              role="tabpanel"
              style="padding-left: 10px;
    padding-right: 10px;"
            >Yes- the killing of a snake that is protected by the law under the Wildlife (Protection) Act, 1972. However, if the killing of a snake happened in self-defense or to save someone else's life, the same can be considered by the investigating officer or the Hon. Court who will take an appropriate decision after looking into the circumstances leading up to the killing of the snake. Therefore, it is preferable to contact a snake rescuer in such a situation rather than handling such a situation on one’s own. You can locate your nearest snake rescuer using this <a href="http://www.indiansnakes.org" target="_blank" style="color:green;">website</a> or download the <a href="https://play.google.com/store/apps/details?id=leopard.tech.lab.big4mapper&hl=en" target="_blank" style="color:green;">SERPENT app</a> on your Android phone</b-collapse>
          </b-card>
          <b-card no-body class="mb-1" style="text-align: left;">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-btn
                block
                href="#"
                v-b-toggle.accordion4
                variant="secondary"
                style="text-align:left;"
              >
                What is the best method to deal with a snake during a human-snake conflict situation?
                <span
                  class="when-opened"
                  style="float:right;"
                >
                  <font-awesome-icon icon="minus-square" />
                </span>
                <span class="when-closed" style="float:right;">
                  <font-awesome-icon icon="plus-square" />
                </span>
              </b-btn>
            </b-card-header>

            <b-collapse
              id="accordion4"
              role="tabpanel"
              style="padding-left: 10px;
    padding-right: 10px;"
            >The best way is to allow the snake to move away from the conflict situation on its own, if the same can be organized. Please remember that most snakes have been living unobserved in the same locality for a long time and given the opportunity it may disappear and not be seen in the future. A snake removal should be done by a trained expert using snake hooks, pipe, and a bag. For more details <a href="https://www.youtube.com/watch?v=scDGVAFVk4c&feature=emb_logo" target="_blank">watch this video.</a></b-collapse>
          </b-card>
          <b-card no-body class="mb-1" style="text-align: left;">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-btn
                block
                href="#"
                v-b-toggle.accordion5
                variant="secondary"
                style="text-align:left;"
              >
                Can I keep a snake as a pet in India ?
                <span
                  class="when-opened"
                  style="float:right;"
                >
                  <font-awesome-icon icon="minus-square" />
                </span>
                <span class="when-closed" style="float:right;">
                  <font-awesome-icon icon="plus-square" />
                </span>
              </b-btn>
            </b-card-header>

            <b-collapse
              id="accordion5"
              role="tabpanel"
              style="padding-left: 10px;
    padding-right: 10px;"
            >No Indian snake species cannot be kept as pet within the country. This includes any species of snakes which are listed under the Wildlife (Protection) Act, 1972. Some snake species are not specifically listed in the Act, but the Family mentioned will include all species under it. There are no legal issues in keeping non- native and non-CITES covered species as pets in India. Legalities aside, keeping snakes as pets is not encouraged from a conservation point of view as many such pet snakes are later released into the wild when the owner tire of them or it becomes too much of a responsibility. This could spell disaster for the biodiversity of the region as these species may become invasive species and destroy native wildlife. The Burmese pythons in Florida are one of the best examples of such a disaster.</b-collapse>
          </b-card>
          <b-card no-body class="mb-1" style="text-align: left;">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-btn
                block
                href="#"
                v-b-toggle.accordion6
                variant="secondary"
                style="text-align:left;"
              >
                Which is the most protected snake in the Country?
                <span
                  class="when-opened"
                  style="float:right;"
                >
                  <font-awesome-icon icon="minus-square" />
                </span>
                <span class="when-closed" style="float:right;">
                  <font-awesome-icon icon="plus-square" />
                </span>
              </b-btn>
            </b-card-header>

            <b-collapse
              id="accordion6"
              role="tabpanel"
              style="padding-left: 10px;
    padding-right: 10px;"
            >All pythons found in India are accorded the highest level of protection under Schedule I of the Wildlife (Protection) Act, 1972. This is due to the huge threat that pythons face from hunting for meat and skin in most parts of India. Currently, their population is increasing across the country and not in any serious threat. The other highly protected snake is the Indian egg eater which has very limited geographical distribution and their numbers may be dwindling due to habitat loss. The exact population status is not known as of now, but they do need strict protection under the law and also habitat-level protection to ensure their survival.</b-collapse>
          </b-card>
          <b-card no-body class="mb-1" style="text-align: left;">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-btn
                block
                href="#"
                v-b-toggle.accordion7
                variant="secondary"
                style="text-align:left;"
              >
                Is rescuing a snake without proper permission from the authorities is illegal?
                <span
                  class="when-opened"
                  style="float:right;"
                >
                  <font-awesome-icon icon="minus-square" />
                </span>
                <span class="when-closed" style="float:right;">
                  <font-awesome-icon icon="plus-square" />
                </span>
              </b-btn>
            </b-card-header>

            <b-collapse
              id="accordion7"
              role="tabpanel"
              style="padding-left: 10px;
    padding-right: 10px;"
            >IAs per the provisions of the  Wildlife (Protection), Act – 1972 ( Act), capturing or attempt to capture a wild animal is an offense under  Section 9 of the Act. The Act does not have any provision to conduct a ‘rescue’  and all capture of wildlife is considered as an act of ‘hunting’. So, the rescue of a snake under any circumstance is considered as hunting whether it is to save the life of the animal or protect a human being from harm. The Act also has provisions to provide permissions to hunt under sections 11& 12 which has to be issued by the  Chief Wildlife Warden or an authorized officer in writing.  So, a rescuer should get such permission from the authorities before he engages in any kind of rescue operation. <br>
Anyone who is suspected/accused of hunting has to prove his innocence in front of the investigation officer/court as the burden of proving innocence is on the accused as per the provisions of the Act. It is a must that anyone who is engaged in a regular snake rescue has a valid permit. </b-collapse>
          </b-card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Navbar from "./navbar";
export default {
  components: {
    Navbar
  },
  data() {
    return {
      text: `
          Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry
          richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor
          brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon
          tempor, sunt aliqua put a bird on it squid single-origin coffee nulla
          assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore
          wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher
          vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic
          synth nesciunt you probably haven't heard of them accusamus labore VHS.
        `
    };
  }
};
</script>
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #ffffff;
}
.collapsed > .when-opened,
:not(.collapsed) > .when-closed {
  display: none;
}
.btn-secondary:hover {
  color: #fff;
  background-color: #785432;
  border-color: #785432;
}
.btn-secondary {
  color: #fff;
  background-color: #785432;
  border-color: #785432;
}
.btn-secondary:not(:disabled):not(.disabled).active,
.btn-secondary:not(:disabled):not(.disabled):active,
.show > .btn-secondary.dropdown-toggle {
  color: #fff;
  background-color: #785432;
  border-color: #785432;
}
</style>